import MainSearch from '../../components/SharedComponents/MainSearch';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(MainSearch);
